import { useTranslation } from "react-i18next";
import {
  SmallButton,
  FilterSelectorOperators as operators,
} from "@etframework/ui.components";
import { DateFormats } from "../../types/DateFormats";
import moment from "moment";
import { SkeletonComponent } from "@syncfusion/ej2-react-notifications";

export const FilterSummary = ({
  tasks,
  filters,
  onReset,
  isUpdateSummary = false,
  ...rest
}) => {
  const { t } = useTranslation(["BulkUpdateTasksModal", "Shared"], {
    useSuspense: false,
  });
  const translationSuffix = isUpdateSummary ? "Review" : "FromActions.Summary";

  const getValue = (filter) => {
    const sttgs = filter.columnSettings;

    if (!sttgs) return `${filter.value}`;

    if (sttgs?.type === "source" && sttgs?.displayProperty) {
      return filter.displayValue.join(", ");
    }

    if (Array.isArray(filter?.value)) {
      return filter.value
        .map((x) => getValue({ ...filter, value: x }))
        .join(", ");
    } else if (filter.type === "date" || filter.type === "dateRange") {
      return getDateFilterDisplayValue(filter.value);
    } else if (typeof filter.value === "boolean")
      return getBooleanDisplayValue(filter.value, sttgs);
    else return `${filter.value}`;
  };

  const getOperator = (filter) => {
    if (filter.operator === operators.Equal) return "";
    else return t("Operators." + filter.operator);
  };

  const getBooleanDisplayValue = (value) => {
    return value ? t("Shared:Yes") : t("Shared:No");
  };

  const getDateFilterDisplayValue = (value) =>
    moment(value).format(DateFormats.ShortDateFormat.momentJsFormat);

  const loading = <SkeletonComponent height={"14px"} width={"150px"} />;

  const header = (
    <div className="d-flex justify-content-between align-items-center mb-3">
      {tasks ? (
        <span>
          <span className="fw-600 et-green-dark">
            {t(`${translationSuffix}.Count`, { count: tasks?.length })}
          </span>
          &nbsp;{t(`${translationSuffix}.Matched`, { count: tasks?.length })}
        </span>
      ) : (
        loading
      )}

      {onReset && (
        <SmallButton
          onClick={onReset}
          iconCss={"fa-regular fa-pencil"}
          text={t(`${translationSuffix}.ResetCriteria`)}
        />
      )}
    </div>
  );

  return (
    <div className={"filter-summary"} {...rest}>
      {header}
      <div className="filter-list">
        {filters
          ?.filter?.((x) => x.value !== null && x.value !== undefined)
          .map?.((filter, index) => (
            <div key={filter?.field + index} className="filter">
              <div className="filter-field">
                {filter.text} {getOperator(filter)}
              </div>
              <div className={`pb-2 fw-600`}>{getValue(filter)}</div>
            </div>
          ))}
      </div>
    </div>
  );
};
